import axios from "axios";
import Instense from "./Axios-config";
import { API_ROOT } from "./Api-config";
 
export class TransactionService {

public static GetDeposits = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  // let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  // request.tenantid = tenantID;
  const url = `/Transaction/GetTransactionDeposit`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static GetInvoice = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  // let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  // request.tenantid = tenantID;
  const url = `/Transaction/GetTransactionInvoice`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetCheckData = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantId = tenantID;
  const url = `/Transaction/GetCheckInvoice`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static MultipleInvoiceData = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantId = tenantID;
  const url = `/Transaction/MultipleInvoiceData`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetJournal = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  // let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  // request.tenantid = tenantID;
  const url = `/Transaction/GetTransactionJournal`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetJournalListing = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantid = tenantID;
  const url = `/Transaction/GetJournal`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetTransfer = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  // let tenantID = storage === null ? 0 : (storage.tenantID as any); 
  // request.tenantid = tenantID;
  const url = `/Transaction/GetTransactionTransfer`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetCOA = async (request: any): Promise<any | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
     
    request.tenantid = tenantID;
    const url = `/ChartofAccounts/GetChartofAccounts`;
    return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
  };

public static SaveDeposits = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;
  const url =`/Transaction/SaveTransactionDeposit`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveJournal = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;
  const url =`/Transaction/SaveTransactionJournal`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveTransfer = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;
  const url =`/Transaction/SaveTransactionTransfer`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveTransactionfiles = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.TenantId = tenantID;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  const url = `/Transaction/SaveTransactionFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static SaveTransferFile = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantid = tenantID;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  const url = `/Transaction/SaveTransferFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static SaveTransactionfilesJournal = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.TenantId = tenantID;

  const url = `/Transaction/SaveTransactionFileJournal`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static SaveVoidTransaction = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;
  const url =`/Transaction/SaveTransactionVoid`;
  return Instense.get(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static DeleteDeposit = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;
  const url =`/Transaction/DeleteTransaction`;
  return Instense.delete(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteBankSync = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;
  const url =`/Transaction/DeleteBankSync`;
  return Instense.delete(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteTransfer = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;
  const url =`/Transaction/DeleteTransfer`;
  return Instense.delete(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteJournal = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;
  const url =`/Transaction/DeleteJournal`;
  return Instense.delete(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteInvoice = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;
  const url =`/Transaction/DeleteInvoice`;
  return Instense.delete(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetUploadFileWithFileCodeTransaction = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // let userUniqueID = storage === null ? 0 : (storage.user_UniqueID as any);
  // debugger

  request.tenantid = tenantID;
  const url = `/Transaction/GetUploadFileWithFileCodeTransaction`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};



public static GetUploadFileWithFileCodeInbox = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // let userUniqueID = storage === null ? 0 : (storage.user_UniqueID as any);
  // debugger

  request.tenantid = tenantID;
  const url = `/Transaction/GetUploadFileWithFileCodeInbox`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
public static DeleteUploadedFileTransaction = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
 
  request.tenantID = tenantID;
  const url = `/Transaction/DeleteTransactionFile`;
  return Instense.post(url, request).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static DownloadTransactionFile = async (
  request: any
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantId = tenantID;

  const url = `/Transaction/DownloadTransactionFile`;
  return Instense.post(url, request, { responseType: "blob" }).then(
    (response: any) => {

      let csvURL = window.URL.createObjectURL(response.data);
      let tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", request.name);
      tempLink.click();
    }
  );
};

public static DownloadTemplate = async (
  request: any
): Promise<any | null> => {
  

  const url = `/Transaction/DownloadTemplateFile`;
  return Instense.post(url, request, { responseType: "blob" }).then(
    (response: any) => {

      let csvURL = window.URL.createObjectURL(response.data);
      let tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "Template.xlsx");
      tempLink.click();
    }
  );
};
   
public static SaveReconcile = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantid = tenantID;
  const url =`/Transaction/SaveReconcileSummary`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetReconcile = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any); 
  request.tenantId = tenantID;
  const url = `/Transaction/GetReconcileSummary`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static CompleteReconcile = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any); 
  request.tenantId = tenantID;
  const url = `/Transaction/CompleteReconcile`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static UpdateReconcile = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any); 
  request.tenantId = tenantID;
  const url = `/Transaction/UpdateReconcileSummary`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveReconcilefiles = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantid = tenantID;

  const url = `/Transaction/SaveReconcilefiles`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static BulkImportInvoiceExcelFile = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;

  const url = `/Transaction/BulkImportInvoiceExcelFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static BulkImportBankExcelFile = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;

  const url = `/Transaction/BulkImportBankExcelFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static BulkImportPayrollExcelFile = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;

  const url = `/Transaction/BulkImportPayrollExcelFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static SaveImportInvoice = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;
  const url =`/Transaction/SaveImportInvoice`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveImportPayroll = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;
  const url =`/Transaction/SaveImportPayroll`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static getImports = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantid = tenantID;
  const url = `/Transaction/GetPayrollImports`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static SaveMappingRule1 = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantid = tenantID;

  const queryParams = new URLSearchParams(request).toString();

  const url = `/Transaction/SaveMappingRule?${queryParams}`;

  return Instense.post(url).then((response) => {
    let result = response.data as any;
    return result;
  });
};

public static SaveMappingRule = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
  request.tenantid = tenantID;
  const url =`/Transaction/SaveMappingRule`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveBankSyncImport = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
  request.tenantid = tenantID;
  const url =`/Transaction/SaveBankSyncImport`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveBankSyncImportMain = async (request: any): Promise<any[] | null> => {

  const url =`/Transaction/SaveBankSyncImportMain`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};



public static GetBankSync = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantid = tenantID;
  const url = `/Transaction/GetBankSync`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static getBankSyncAll = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantid = tenantID;
  const url = `/Transaction/getBankSyncAll`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static ExcludeRecords = async (request: any): Promise<any[] | null> => {
  const url =`/Transaction/ExcludeRecords`;
  return Instense.post(url,request).then((response) => {
    debugger;
    let result = response.data.result as any;
    return result;
  });
};

public static IncludeRecords = async (request: any): Promise<any[] | null> => {
  const url =`/Transaction/IncludeRecords`;
  return Instense.post(url,request).then((response) => {
    debugger;
    let result = response.data.result as any;
    return result;
  });
};

public static ReconcileBankSync = async (request: any): Promise<any[] | null> => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url =`/Transaction/ReconcileBankSync`;
  return Instense.post(url,request).then((response) => {
    debugger;
    let result = response.data.result as any;
    return result;
  });
};



 public static GetMappingRules = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Transaction/GetMappingRules`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static UpdateReconcileBankSync = async (request: any): Promise<any | null> => {
  
  const url = `/Transaction/UpdateReconcileBankSync`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static LastUpload = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Transaction/GetLastUpload`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetadjCoa = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Transaction/GetadjCoa`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetAccountingPeriods = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Transaction/GetAccountingPeriods`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteDocument = async (
  request:  any
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantId = tenantID;
  const url = `/Transaction/DeleteDocument`;
  return Instense.delete(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static SaveAccountingPeriods = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
  request.tenantid = tenantID;
  const url =`/Transaction/SaveAccountingPeriods`;
  return Instense.post(url,request).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetAccountingPeriodList = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantid = tenantID;
  const url =`/Transaction/GetAccountingPeriodList`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static SplitVendorInvoice = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;
  const url = `/Transaction/SplitVendorInvoice`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

}


